import type { DriverStatus } from '@logistech/ui-shared';

// Aligné sur l'enum DriverStatus (fleet-service, routes/drivers/update.controller.ts)
export const DRIVER_STATUS_LABELS: Record<DriverStatus, string> = {
  ACTIVE: 'Actif',
  OFF_DUTY: 'En repos',
  SUSPENDED: 'Suspendu',
  TERMINATED: 'Sorti des effectifs',
};

export const DRIVER_STATUS_VARIANT: Record<DriverStatus, 'success' | 'secondary' | 'warning' | 'destructive'> = {
  ACTIVE: 'success',
  OFF_DUTY: 'secondary',
  SUSPENDED: 'warning',
  TERMINATED: 'destructive',
};

/** Permis expiré ou expirant dans les 30 jours */
export const licenseAlert = (expiry: string | null): 'expired' | 'soon' | null => {
  if (!expiry) return null;
  const days = (new Date(expiry).getTime() - Date.now()) / 86_400_000;
  if (days < 0) return 'expired';
  return days <= 30 ? 'soon' : null;
};

export const fmtDay = (d: string | null) => (d ? new Date(d).toLocaleDateString('fr-FR') : '—');
